import React from 'react';
import { motion } from "framer-motion"
import "../css/sectionLR.css"



function SectionLR(props) {


return(
    <div className={"section "+ props.LR}>

        <img className="bg-img" src={props.bg}></img>

        <div className="text dm1">
        <motion.h3
        
        initial={{ y: 0, opacity:0 }}
        viewport={{ once: true }}
        whileInView={{ y: 0, opacity:1, 
        transition:{                
                type: "spring",
                duration: 2,
                delay:0,} }}
        >{props.header}</motion.h3>
        <motion.p
        
        initial={{ y: 0, opacity:0 }}
        viewport={{ once: true }}
        whileInView={{ y: 0, opacity:1, 
        transition:{                
                type: "spring",
                duration: 2,
                delay:0,} }}
        >{props.text}</motion.p>
        </div>



        <div className="image">

        <motion.img className="image-self" src={props.image} alt=''
        
        initial={{ y: 0, opacity:0 }}
        viewport={{ once: true }}
        whileInView={{ y: 0, opacity:1, 
        transition:{                
                type: "spring",
                duration: 2,
                delay:0,} }}
        ></motion.img>
        </div>
    </div>
)    
}

export default SectionLR;